import { UpdateDrinkDetails } from "../actions";
import { DrinkingDay } from "@dcc/types/drinkingDay";

export const updateAverageDayDrinkQuantityReducer = (
  state: DrinkingDay,
  payload: UpdateDrinkDetails
): DrinkingDay => {
  return {
    ...state,
    [payload.drink]: payload.amount
  };
};
